<template>
  <v-row no-gutters justify="center">
    <v-col cols="12" style="margin-top: 120px" />
    <div class="welcomeCard">
      <div
        style="background: #fed85d; padding: 40px 100px 40px 100px; border-radius: 30px 30px 0px 0px;"
      >
        <div class="welcomeTitle">
          Welcome
        </div>
        <div class="welcomeText">
          Sign in to receive FREE GM packs and win your favorite artist’s
          official merchandise!
        </div>
      </div>
      <div style="padding: 40px 100px 40px 100px; ">
        <div class="textFieldLabel">
          Sign up or sign in
        </div>
        <v-text-field
          v-model="email"
          outlined
          hide-details
          label="Enter your email"
          style="background: #fff; margin-bottom: 24px;"
        />
        <div class="textFieldLabel">
          Password
        </div>
        <v-text-field
          v-model="password"
          outlined
          hide-details
          label="Enter password"
          type="password"
          style="background: #fff; margin-bottom: 24px;"
        />
        <v-btn
          id="sign-in-button"
          class="yellowButton signupButton "
          block
          depressed
          text
          @click="emailSignIn"
        >
          Sign in
        </v-btn>
        <div style="margin-top: 16px;" />
        <v-btn
          class="googleSignInButton"
          depressed
          text
          block
          @click="googleSignIn"
        >
          Google Login
          <v-icon size="16" style="margin-left: 24px">
            mdi-google
          </v-icon>
        </v-btn>
        <v-card-actions class="mt-8">
          <v-spacer />
          <v-btn class="resetPasswordButton" text @click="resetPassword">
            Reset password with Email
          </v-btn>
          <v-spacer />
        </v-card-actions>
      </div>
    </div>
    <v-col cols="12" style="margin-top: 120px" />
  </v-row>
</template>

<script>
  import {
    RecaptchaVerifier,
    signInWithPopup,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    GoogleAuthProvider,
    onAuthStateChanged,
    // signOut,
  } from 'firebase/auth';

  import Firebase from '@/lib/firebase';
  import { mapActions } from 'vuex';
  import AuthenticationManager from '@/controllers/AuthenticationManager';

  export default {
    name: 'Home',

    data: () => ({
      email: null,
      password: null,
    }),

    computed: {
      auth() {
        return Firebase.auth;
      },
    },

    mounted() {
      onAuthStateChanged(this.auth, (user) => {
        if (user) {
          this.authenticate(user);
        } else {
          window.recaptchaVerifier = new RecaptchaVerifier(
            'sign-in-button',
            {
              size: 'invisible',
              callback: (response) => {
                console.log(response);
              },
            },
            this.auth
          );
        }
      });
    },

    methods: {
      ...mapActions({ setUser: 'setUser' }),
      authenticate: async function(firebaseUser) {
        const user = await AuthenticationManager.authenticate(
          firebaseUser,
          this.phoneNumber
        );
        this.setUser(user);
        if (this.$route.query && this.$route.query.source) {
          this.$router.replace(this.$route.query.source);
        } else {
          this.$router.replace('/');
        }
      },

      async resetPassword() {
        try {
          await sendPasswordResetEmail(this.auth, this.email);
          window.alert(`Password reset instruction sent to ${this.email}`);
        } catch (error) {
          this.$emit('onError', error);
        }
      },

      async emailSignUp() {
        try {
          await createUserWithEmailAndPassword(
            this.auth,
            this.email,
            this.password
          );
        } catch (error) {
          console.log(error.message);
          this.$emit('handleError', error);
        }
      },

      async emailSignIn() {
        try {
          await signInWithEmailAndPassword(
            this.auth,
            this.email,
            this.password
          );
        } catch (error) {
          if (error.code === 'auth/user-not-found') {
            console.log('user does not exist');
            this.emailSignUp();
          } else {
            console.log(error);
            this.$emit('handleError', error);
          }
        }
      },

      async googleSignIn() {
        try {
          const provider = new GoogleAuthProvider();
          await signInWithPopup(this.auth, provider);
        } catch (error) {
          this.$emit('handleError', error);
        }
      },
    },
  };
</script>

<style scoped>
  .welcomeCard {
    width: 600px;
    background: #ffffff;

    border: 1px solid #a1a1a1;
    box-shadow: 0px 4px 100px rgba(0, 0, 0, 0.25);
    border-radius: 30px;
  }
  .welcomeTitle {
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 700 !important;
    font-size: 57px !important;
    line-height: 64px !important;
    color: #000;
  }
  .welcomeText {
    margin-top: 8px;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 20px !important;
    color: #000;
  }

  .signupButton {
    margin-top: 48px;

    height: 56px !important;
    margin: 0px !important;

    border-radius: 28px !important;

    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 32px;

    letter-spacing: 0.05em;
    text-transform: uppercase;
  }
  .googleSignInButton {
    height: 56px !important;
    margin: 0px !important;

    border: 1px solid #a1a1a1;
    border-radius: 28px !important;

    font-family: 'Work Sans' !important;
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 32px;

    letter-spacing: 0.05em;
    text-transform: uppercase;

    background: #fff !important;

    color: #000 !important;
  }

  .resetPasswordButton {
    margin: 0px !important;
    font-family: 'Work Sans' !important;
    font-style: normal !important;
    font-weight: 500 !important;
    font-size: 16px !important;
  }
</style>
